(function ($) {
 	$.fn.capitechIncomingMessages = function() {
		var ctIncomingMessagesModel;
		var $ctIncomingMessagesElm = $(this);
		var options = {}
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			options = { 
				extend: {
					"{root}": function(incomingMessages) {
						incomingMessageTemplate = function (incomingMessage) {
							if (incomingMessage.status() !== 'Acknowledged') {
								return 'createdIncomingTemplate';
							} else {
								return 'defaultIncomingTemplate';
							}
						};
						markMessageAsAcknowledged = function (incomingMessage) {
							var success = function success(data, textStatus, jqXHR) {
								// Hide loader
								loaderIndicator(false);
								if (data.success == true) {
									incomingMessage.status('Acknowledged');
									updateUnReadCount();
								} else {
									sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
								}
							};
							var error = function error(jqXHR, textStatus, errorThrown) {
								// Hide loader
								loaderIndicator(false);
								sweetAlert("Error", errorThrown, "error");
							};
							// Show loader
							loaderIndicator(true);
							_api.markMessageAsAcknowledged_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), incomingMessage.id());
						};
					}
				}
			}
			getIncomingMessages();
		}
		
		function getIncomingMessages() {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				
				// Hide loader
				loaderIndicator(false);
				
				if (data.success == true) {
					modelData.incomingMessages = data.content;
					ctIncomingMessagesModel = ko.viewmodel.fromModel(modelData, options);
					$('*[data-ko-bind="ctIncomingMessagesModel"]').each(function(index, obj) {
						ko.applyBindings(ctIncomingMessagesModel, obj);
					});
					// Update unread messagecount
					updateUnReadCount();
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// Hide loader
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			// Show loader
			loaderIndicator(true);
			_api.getIncomingMessages_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), true, null);
		}
		
		function updateUnReadCount() {
			var unReadMessageCount = 0;
			ko.utils.arrayForEach(ctIncomingMessagesModel.incomingMessages(), function(incomingMessage) {
				if (incomingMessage.status() !== 'Acknowledged') {
					unReadMessageCount += 1;
				}
			});
			setLocalStorage('myCapitechUnReadMessageCount', unReadMessageCount);
			ctUnreadMessagesModel.unreadMessageCount(unReadMessageCount);
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));